import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _possibleConstructorReturn from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { ReEnrollAuthenticator } from './ReEnrollAuthenticator.js';
var ReEnrollAuthenticatorWarning = /*#__PURE__*/function (_ReEnrollAuthenticato) {
  function ReEnrollAuthenticatorWarning() {
    _classCallCheck(this, ReEnrollAuthenticatorWarning);
    return _callSuper(this, ReEnrollAuthenticatorWarning, arguments);
  }
  _inherits(ReEnrollAuthenticatorWarning, _ReEnrollAuthenticato);
  return _createClass(ReEnrollAuthenticatorWarning);
}(ReEnrollAuthenticator);
ReEnrollAuthenticatorWarning.remediationName = 'reenroll-authenticator-warning';
export { ReEnrollAuthenticatorWarning };